export class Email {
    id: string;
    libelle: string;
    valeur: string;

    constructor(){}
}
